{
  "page": {
    "title": "API Keys",
    "subtitle": "Manage keys for the Partner Order API"
  },
  "section": {
    "aria": "Partner API keys",
    "title": "API Keys",
    "subtitle": "Create and manage keys for the Partner Order API. Secrets are shown once."
  },
  "table": {
    "key": "Key",
    "label": "Label",
    "status": "Status",
    "lastUsed": "Last used",
    "usage": "Usage (req / err / orders)",
    "actions": "Actions",
    "neverUsed": "never used",
    "noActions": "—",
    "revokeOrphanHint": "This key was never used — revoke it if the secret was lost."
  },
  "status": {
    "active": "Active",
    "revoked": "Revoked"
  },
  "empty": {
    "title": "No API keys yet",
    "subtitle": "Create a key to start using the Partner Order API from your systems.",
    "cta": "Create your first API key"
  },
  "create": {
    "aria": "Create API key",
    "title": "Create API key",
    "subtitle": "Give the key a label so you can recognise it later.",
    "labelField": "Label",
    "labelPlaceholder": "e.g. Production",
    "labelRequired": "Enter a label",
    "copied": "Copied",
    "copyFailed": "Copy the key manually"
  },
  "reveal": {
    "title": "API key created",
    "subtitle": "Copy your secret now. For security it will not be shown again.",
    "warning": "This is the only time the full key is shown. Store it somewhere safe — you won't be able to see it again.",
    "secretLabel": "Your API key",
    "copyAria": "Copy API key",
    "done": "I saved the key"
  },
  "revoke": {
    "aria": "Revoke API key",
    "title": "Revoke this API key?",
    "body": "The key stops working immediately and cannot be restored. Any integration using it will start failing.",
    "confirmTitle": "Confirm revoke",
    "confirmBody": "This is permanent. You will need to create a new key to reconnect.",
    "success": "API key revoked",
    "error": "Could not revoke key"
  },
  "actions": {
    "create": "Create API key",
    "cancel": "Cancel",
    "continue": "Continue",
    "revoke": "Revoke",
    "retry": "Retry"
  },
  "errors": {
    "loadFailed": "Could not load your API keys.",
    "network": "Network error - check connection"
  }
}
